// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';

const Navbar = () => {
 
  return (
  <>
  
  </>
  );
};

export default Navbar;
